import { Component, OnInit, inject } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { Store } from '@ngrx/store';
import { filter, map, startWith } from 'rxjs';

import { AppState } from './app.state';
import { NavbarComponent } from './components/navbar/navbar.component';
import { TopbarComponent } from './components/topbar/topbar.component';
import { PlayerBarComponent } from './components/player-bar/player-bar.component';
import { initUserCountryCode } from './player.actions';
import { loadPresetsFromStorage } from './equalizer.actions';
import { MetaTagsService } from './services/meta-tags.service';
import { LayoutService } from './services/layout.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, NavbarComponent, TopbarComponent, PlayerBarComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  protected readonly layout = inject(LayoutService);
  private readonly store = inject(Store<AppState>);
  private readonly metaTagsService = inject(MetaTagsService);
  private readonly router = inject(Router);

  ngOnInit(): void {
    this.metaTagsService.setDefaultMetatags();
    this.store.dispatch(initUserCountryCode());
    // Restore the equalizer the user last used, so it is already in place
    // before they open the equalizer view.
    this.store.dispatch(loadPresetsFromStorage());
    this.trackCanonicalUrl();
  }

  /**
   * Keeps the canonical URL on the route being viewed.
   *
   * Done once here rather than in each view: every route then gets a correct
   * canonical, including the ones that set no meta tags of their own. Query
   * strings and fragments are dropped so filtered views fold into one URL.
   */
  private trackCanonicalUrl(): void {
    this.router.events
      .pipe(
        filter((event): event is NavigationEnd => event instanceof NavigationEnd),
        map((event) => event.urlAfterRedirects),
        startWith(this.router.url),
      )
      .subscribe((url) => {
        this.metaTagsService.setCanonicalUrl(url.split(/[?#]/)[0]);
      });
  }
}
